const style = {
  sideSelect: {
    display: 'flex',
    position: 'fixed',
    top: 304,
    right: 0,
    width: '250px',
    flexDirection: 'column',
    boxShadow: '-2px 0px 4px #b8b8b8',
    height: '100vh',
    backgroundColor: '#fff',
    transform: 'translate(200%, 0)',
    transition: 'transform 0.3s ease-in-out',
  },

  sideSelectActive: {
    display: 'flex',
    position: 'fixed',
    top: 304,
    right: 0,
    width: '250px',
    flexDirection: 'column',
    boxShadow: '-2px 0px 4px #b8b8b8',
    height: '100vh',
    backgroundColor: '#fff',
    transform: 'translate(0, 0)',
    transition: 'transform 0.3s ease-in-out',
  },

  sideSelectHeader: {
    padding: '36px 0',
    display: 'flex',
    justifyContent: 'center',
    borderBottom: '1px solid rgba(0, 0, 0, .2)',
  },
  selectItemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '28px',
  },
  selectItem: {
    display: 'flex',
    flexDirection: 'row',
    height: '64px',
    width: '100%',
    border: '1px solid rgba(0, 0, 0, .2)',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  itemIcon: {
    width: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  itemTitle: {
    width: '140px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}
export default style
